export const ROLE_SUPER_ADMIN = "super_admin";

export const ROLE_ADMIN = "admin";

export const ROLE_USER = "user";